/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPentagon: {
  name: 'pentagon';
  data: string;
} = {
  name: 'pentagon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.146 1.983a1.5 1.5 0 0 1 1.708 0l5.314 3.679a1.5 1.5 0 0 1 .57 1.708l-2.036 6.104A1.5 1.5 0 0 1 11.28 14.5H4.721a1.5 1.5 0 0 1-1.423-1.026L1.263 7.37a1.5 1.5 0 0 1 .57-1.708l5.313-3.679Zm1.139.822a.5.5 0 0 0-.57 0l-5.314 3.68a.5.5 0 0 0-.19.568l2.035 6.105a.5.5 0 0 0 .475.342h6.558a.5.5 0 0 0 .475-.342l2.035-6.105a.5.5 0 0 0-.19-.569L8.285 2.805Z" fill="currentColor"/></svg>`,
};
